import type { CoreData, NameEntry, SexPref } from "./types";

export function originTitle(origin: string): string {
  return `${origin} names`;
}

export const ORIGIN_NOTE: Record<string, string> = {
  Modern: "Names coined or taken up in the last hundred years or so: new spellings, blends and words used as names.",
  Germanic: "Names from the early Germanic languages, many brought to Britain by the Normans.",
};

/** How many names in the deck come from each origin, most first. */
export function originCounts(core: CoreData, keep: (e: NameEntry) => boolean): [string, number][] {
  const m = new Map<string, number>();
  for (const e of core.entries) if (e.origin && keep(e)) m.set(e.origin, (m.get(e.origin) ?? 0) + 1);
  return [...m.entries()].sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]));
}

/** Each origin's best-known names (by this year's rank), to show what its names are like. */
export function originExamples(
  core: CoreData,
  keep: (e: NameEntry) => boolean,
  rankOf: (e: NameEntry) => number,
  n = 3,
): Map<string, string[]> {
  const ranked = core.entries.filter((e) => e.origin && keep(e) && rankOf(e) > 0).sort((a, b) => rankOf(a) - rankOf(b));
  const out = new Map<string, string[]>();
  for (const e of ranked) {
    const list = out.get(e.origin!) ?? [];
    if (list.length < n) out.set(e.origin!, [...list, e.name]);
  }
  return out;
}

/** "Hebrew", "Hebrew and Latin", "Hebrew, Latin and 2 more" */
export function listWords(items: string[], max = 3): string {
  if (items.length <= 1) return items[0] ?? "";
  if (items.length > max) return `${items.slice(0, max - 1).join(", ")} and ${items.length - max + 1} more`;
  return `${items.slice(0, -1).join(", ")} and ${items[items.length - 1]}`;
}

export function sexWordPossessive(sex: SexPref): string {
  return sex === "F" ? "Girls' names" : sex === "M" ? "Boys' names" : "Names";
}
